import { render } from "./LoginRootCaptchaEsp.vue?vue&type=template&id=02f0fe40"
import script from "./LoginRootCaptchaEsp.vue?vue&type=script&lang=js"
export * from "./LoginRootCaptchaEsp.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__